<template>
    <tenants-store
        v-slot="{
            sid,
            error,
            is_loading,
            has_loaded,
            store
        }"
        @success="onTenantsStoreSuccess"
        @error="onTenantsStoreError"
    >
        <with-variables
            :variables="{
                is_saving: has_loaded || is_loading
            }"
            v-slot="{
                is_saving
            }"
        >
            <base-form @submit="store(form)">
                <div class="px-6 pt-6 border-b">
                    <validator-alert :sid="sid" />

                    <h1 class="mb-6 text-lg font-normal text-center">
                        Create a <strong>tenant</strong> profile
                    </h1>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="first_name"
                    >
                        <template slot="label">First name</template>

                        <input-text
                            v-model="form.first_name"
                            :sid="sid"
                            :autofocus="true"
                            :disabled="is_saving"
                            name="first_name"
                        />
                    </form-item>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="last_name"
                    >
                        <template slot="label">Last name</template>

                        <input-text
                            v-model="form.last_name"
                            :sid="sid"
                            :disabled="is_saving"
                            name="last_name"
                        />
                    </form-item>
                </div>

                <div class="px-6 py-3 text-right rounded-b bg-grey-bg">
                    <base-button
                        :is-loading="is_saving"
                        class="w-full btn-blue"
                    >
                        Create Profile
                    </base-button>
                </div>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </base-form>
        </with-variables>
    </tenants-store>
</template>

<script>
    import _ from 'lodash'
    import scroll from '../../../support/scroll'
    import HeadMixin from '../../../mixins/head'
    import PreloadedMixin from '../../../mixins/preloaded'
    import TenantsStore from '../../../components/tenants-store'

    export default {
        mixins: [
            HeadMixin,
            PreloadedMixin
        ],
        components: {
            TenantsStore
        },
        data () {
            return {
                form: {
                    first_name: '',
                    last_name: ''
                }
            }
        },
        methods: {
            head () {
                const address = _.get(this.preloaded('application'), 'data.listing.property.address.name')

                return {
                    title: [
                        'Account',
                        `${address} Application`
                    ]
                }
            },
            onTenantsStoreSuccess ({ data: tenant, meta }) {
                this.$track(
                    'auth.tenants.create',
                    'form-submission',
                    'A user has created a tenant persona'
                )

                setTimeout(() => {
                    const applicant = _.get(_.preload('applicant'), 'data.uuid', '')

                    window.location = this.$laroute.route('applications.applicants.create', {
                        application: this.$route.params.application,
                        applicant,
                        tenant: tenant.uuid
                    })
                }, 0)
            },
            onTenantsStoreError () {
                scroll.toTop()
            }
        }
    }
</script>
